import React, { FC, useMemo } from 'react';
import { useTenderData } from 'src/models/procurements/Tender/hooks';
import { Expand } from 'src/common';
import { TenderSubCatName } from 'src/models/procurements/Tender/types';
import ReadOnlyTextBlock from 'src/shared/Blocks/Text/ReadOnlyBlock';
import { ListBox, TenderSubCat } from 'src/shared';
import styles from '../Cpv/index.module.scss';
import { useTranslation } from 'react-i18next';

export const LotsSubCat: FC = () => {
  const { data } = useTenderData();
  const subCat = useMemo(() => data?.generalCat[TenderSubCatName.Lots], [data]);
  const lots = useMemo(() => subCat?.lots, [subCat]);
  const { t } = useTranslation();

  return (
    <>
      {!!subCat && !!lots && !!lots.length && (
        <TenderSubCat subCat={subCat}>
          <Expand
            visibility={165}
            showMoreTitle={t('Common.showAll')}
            isListExpandable
            isDescription
            buttonClassName={styles.expandButton}
          >
            {lots.map(({ lotItem, name, description, id }) => (
              <ListBox
                key={id}
                title={name ?? undefined} // for what
                value={description ? <ReadOnlyTextBlock string={description} /> : undefined}
                index={lotItem}
              />
            ))}
          </Expand>
        </TenderSubCat>
      )}
    </>
  );
};

export default LotsSubCat;
